var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryFilledLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1934 12.3534C15.9295 12.3534 14.8651 13.3877 14.8651 14.616C14.8651 16.2968 17.1934 18.818 17.1934 18.818C17.1934 18.818 19.5216 16.2968 19.5216 14.616C19.5216 13.3877 18.4573 12.3534 17.1934 12.3534ZM17.1934 15.4564C16.7277 15.4564 16.3951 15.0685 16.3951 14.6806C16.3951 14.2281 16.7942 13.9049 17.1934 13.9049C17.5925 13.9049 17.9916 14.2928 17.9916 14.6806C18.0582 15.0685 17.659 15.4564 17.1934 15.4564ZM14.5658 17.5251H7.54772C7.19487 17.5251 6.85647 17.3889 6.60696 17.1464C6.35746 16.9039 6.21729 16.5751 6.21729 16.2321V8.47457C6.21729 8.13166 6.35746 7.8028 6.60696 7.56033C6.85647 7.31786 7.19487 7.18164 7.54772 7.18164H18.1912C18.9296 7.18164 19.5216 7.75699 19.5216 8.47457V11.9008C19.1325 11.5814 18.6795 11.3437 18.1912 11.2027V9.7675H7.54772V11.7069H15.1245C14.1733 12.3534 13.5347 13.4265 13.5347 14.616C13.5347 15.5857 14.0136 16.6265 14.5658 17.5251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryFilledLogo);
export default __webpack_public_path__ + "static/media/delivery-filled-logo.122897d2248a36f4122ddcb8fb1dad67.svg";
export { ForwardRef as ReactComponent };